/**
 * Copyright © 2025 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import React from "react";
import { Dialog, DialogContent } from "@mui/material";
import { CrossIconContainer, StyledDialogTitle, LoaderContainer } from "../audit_log_modal/styles";
import ClearIcon from '@mui/icons-material/Clear';
import { Loader } from "../loader";
import { ModalTable } from "../modal_table"
import camelize from "../../utils/camelize";
import { formatDate } from "../../utils/formatDate";

export const UserActivityLogModal = ({
  open,
  setOpen,
  data,
  isLoading,
  modalPage,
  setModalPage,
  modalPerPage,
  setModalPerPage,
  modalPageCount,
}) => {

  const handleClose = () => {
    setOpen(false)
  }

  const tableColumns = [
    { key: "platform", sortable: true },
    { key: "app_version", sortable: true },
    { key: "os_version", sortable: true },
    { key: "last_used", sortable: true },
  ];

  const columns = tableColumns?.map((column) => {
    return {
      key: column.key,
      label: camelize(column.key),
      sortable: column.sortable,
    };
  });

  const TableRows = (data) => {
    return data?.map((record) => {
      return {
        platform: record?.platform || '-',
        app_version: record?.app_version || '-',
        os_version: record?.os_version || '-',
        last_used: formatDate(record?.last_used, record?.time_zone_abbr || 'CDT')
      }
    });
  };

  const rows = TableRows(data);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      sx={{
        "& .MuiPaper-root": {
          minWidth: "700px !important",
          minHeight: "500px !important",
        },
      }}
      data-testid="user-activity-log-modal"
    >
      <CrossIconContainer>
        <ClearIcon 
          onClick={handleClose}
          data-testid="user-activity-log-modal-close-icon"
        />
      </CrossIconContainer>

      <StyledDialogTitle
        data-testid="user-activity-log-modal-title"
      >
        Mobile User Activity Log
      </StyledDialogTitle>
      <DialogContent>
        {
          isLoading ? (
            <LoaderContainer>
              <Loader />
            </LoaderContainer>
          ) : (
            <ModalTable
              columns={columns}
              data={rows || []}
              type="mobile user activity log"
              report={false}
              hideNavigation={false}
              itemsPerPage={modalPerPage}
              setItemsPerPage={setModalPerPage}
              page={modalPage}
              setPage={setModalPage}
              pageCount={Number(modalPageCount) || 0}
              emptyStateText="No sync logs available for the last 30 days"
            />
          )
        }
      </DialogContent>
    </Dialog>
  )
}
